import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentLanguageCountryKey, getLanguageList } from '@pm/super-library-2/utils';

// import { getLanguageList } from '../../util/language-util';

const initialState = {
    currentLanguage: {
        countryName: '',
        display: '',
    },
    languageList: [],
    processedLanguageList: [],
};

const getCurrentSetByKey = (languageList, languageKey) => {
    let languageSet;
    languageList.forEach(({ languages }) => {
        languages.forEach((language) => {
            if (language.countryLanguageKey === languageKey) {
                languageSet = language;
                return;
            }
        });
    });

    return languageSet;
};

export const fetchLanguageList = createAsyncThunk('language-slice/fetchLanguageList', async (_, { getState }) => {
    const allState = getState();
    // portalSettings Redux is a fallback, mostly should have window.portalSettings
    const portalSettings = allState?.portalSettingsReducer?.portalSettings;
    const _portalSettings = window.portalSettings || portalSettings;
    const { countryLanguageKey } = getCurrentLanguageCountryKey();
    const response = _portalSettings?.languages ? getLanguageList(_portalSettings) : [];
    const currentLanguage = getCurrentSetByKey(response, countryLanguageKey);

    return { languageList: response, currentLanguage };
});

export const setCurrentLanguageByKey = createAsyncThunk('language-slice/setCurrentLanguageByKey', async (payload) => {
    const { selectedLanguage } = payload;

    /** Currently remove this to utilize default redux language */

    // const { key, countryLanguageKey, currency: currencyLang } = selectedLanguage;
    // const lengthLanguage = countryLanguageKey.length;
    // const country = countryLanguageKey.substring(lengthLanguage - 2, lengthLanguage);
    // try {
    //     localStorage.setItem('language', key);
    //     localStorage.setItem('LANGUAGE_CURRENCY', countryLanguageKey);
    //     localStorage.setItem('country', country);
    //     localStorage.setItem('currencyLang', currencyLang);
    //     localStorage.setItem('userCurrencyLang', userCurrency);
    // } catch (error) {
    //     console.error('save state', error);
    // }

    return selectedLanguage;
});

export const languageSlice = createSlice({
    name: 'language-slice',
    initialState,
    reducers: {
        setCurrentLanguage: (state, action) => {
            state.currentLanguage = action.payload;
        },
        setProcessedLanguageList: (state, action) => {
            state.processedLanguageList = action.payload || [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLanguageList.fulfilled, (state, action) => {
            const { currentLanguage, languageList } = action?.payload || {};
            state.currentLanguage = currentLanguage;
            state.languageList = languageList;
        });
        builder.addCase(setCurrentLanguageByKey.fulfilled, (state, action) => {
            let languageObj = action?.payload;
            if (!languageObj.countryName) {
                languageObj = getCurrentSetByKey(state.languageList, languageObj.countryLanguageKey);
            }
            state.currentLanguage = languageObj;
        });
    },
});

// Action creators are generated for each case reducer function
export const { setCurrentLanguage, setProcessedLanguageList } = languageSlice.actions;

export default languageSlice.reducer;
